export default __webpack_public_path__ + "static/media/career.98250338.svg";